export default {
  lang: {
    selectAll: 'Seleziona tutte le pagine',
    selected: 'Selezionato',
    term: 'Articolo',
    deselect: 'Deseleziona',
  },
};
